import { Fragment } from 'react'

const escape = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Rendert einen Fließtext und hebt einzelne Textstellen fett hervor.
 *
 * So bleiben die Inhalte in `content.ts` reiner Text (gut für Übersetzung,
 * Suche und Tests) und die Auszeichnung steht daneben statt im Text.
 */
export function Rich({
  text,
  strong = [],
}: {
  text: string
  /** Wörtlich vorkommende Textstellen, die fett gesetzt werden. */
  strong?: string[]
}) {
  if (strong.length === 0) return <>{text}</>

  // Längste Treffer zuerst, damit „CAP GO“ nicht von „CAP“ zerschnitten wird.
  const terms = [...strong].sort((a, b) => b.length - a.length)
  const parts = text.split(new RegExp(`(${terms.map(escape).join('|')})`, 'g'))

  return (
    <>
      {parts.map((part, index) =>
        terms.includes(part) ? (
          <strong key={index} className="font-bold">
            {part}
          </strong>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </>
  )
}
